import { Stack, Typography, useTheme } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { permissionEnums } from 'constants/permission.constants';
import { hasPermission } from 'components/AuthorizationComponent';
import _ from 'lodash';
import { getAllBenefits } from 'state/reducers/benefits.reducer';
import { ClientPaginatedTable } from 'components/table';
import { timing } from 'constants/ui.constants';
import * as TableConfig from './tablesConfig';

export const BenefitsTable = () => {
	const theme = useTheme();
	const dispatch = useAppDispatch();
	const t = useAppSelector(selectTranslations);
	const canCreateBenefit = hasPermission([permissionEnums.CREATE_BENEFIT]);
	const benefits = useAppSelector(getAllBenefits);

	return (
		<>
			<Stack spacing={4}>
				{benefits?.length && (
					<ClientPaginatedTable
						dateFormat={timing.DATE}
						rowsClass="alignTop"
						data={TableConfig.tableData(benefits)}
						defaultSortBy="createdAt"
						defaultOrderBy="desc"
						columns={TableConfig.buildColumns(t, dispatch, canCreateBenefit)}
					/>
				)}

				{!benefits?.length && (
					<Typography sx={{ textAlign: 'center' }}>{`${t(
						'page.benefits_management.noBenefitsMessage'
					)}`}</Typography>
				)}
			</Stack>
		</>
	);
};
